// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price_sale":"css-WFR4ilIL4r","price_oldPrice":"css-2zEtOT7JoT","price__soldOut":"css-25KQymy_lz","price__soldOutProduct":"css-L0s1GdwBsD"};